export default __webpack_public_path__ + "static/media/reaper-intro2.a6515d7c.mp3";